<template>
  <div id="modal">
    <section id="workspace" role="dialog" tabindex="-1" aria-label=""
             aria-modal="true" aria-describedby="modal-content-id" class="slds-modal slds-fade-in-open">
      <div class="slds-modal__container">
        <header class="slds-modal__header slds-modal__header_empty">
          <button class="slds-button slds-button_icon slds-modal__close slds-button_icon-inverse close_modal"
                  title="Close" @click="handleClose">
            <svg class="slds-button__icon slds-button__icon_large" aria-hidden="true">
              <use xlink:href="@salesforce-ux/design-system/assets/icons/utility-sprite/svg/symbols.svg#close"></use>
            </svg>
            <span class="slds-assistive-text">Close</span>
          </button>
        </header>
        <div class="slds-modal__content slds-p-around_medium" id="modal-content-id">
          <slot name="body"></slot>
        </div>
        <footer class="slds-modal__footer">
          <slot name="footer"></slot>
        </footer>
      </div>
    </section>
    <div class="slds-backdrop slds-backdrop_open"></div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  methods: {
    handleClose() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>

</style>